import {Modal, Button, Row, Form, Col, InputGroup, FloatingLabel, Container, Tab} from 'react-bootstrap';
import React, {useEffect, useRef, useState} from 'react';

import JSONRegions from '../../../../json/databasecomuni/italy_regions.json'
import JSONProvincies from '../../../../json/databasecomuni/italy_provincies.json'
import JSONCities from '../../../../json/databasecomuni/italy_cities.json'
import JSONSystemRoles from '../../../../json/system/system_roles.json'

import {Link, useNavigate} from "react-router-dom";
import axios from "axios";
import {useAppUniqueToken} from "../../hooks/useAppUniqueToken";
import CodiceFiscale from 'codice-fiscale-js';
import {defaultNONE, previousYear, defaultQuota, defaultEMPTY, defaultINTPHONECODE} from "../../config/global";
import {useToolkit} from "../../hooks/useToolkit";
import {useSanctum} from "react-sanctum";
import LoadingSpinner from "../toolkit/LoadingSpinner";
import {payloadUser, userData} from "../../config/types";
import UsersAccordion from "../toolkit/UsersAccordion";
import {useTranslation} from "react-i18next";
import {toast} from "react-custom-alert";
import PhoneInput from "react-phone-input-2";
import UserDestroyConfirmation from "../modals/UserDestroyConfirmation";
import ZeroSubscriptions from "../modals/ZeroSubscriptions";


interface IProps {
    yourProfile: boolean,
    data: any
}

const UserForm = ({ yourProfile, data, ...props }: IProps)  => {
    const { t } = useTranslation();
    let navigate = useNavigate();
    const {authenticated, user, setUser } = useSanctum();
    const [showUserDestroyConfirmationModal, setShowUserDestroyConfirmationModal] = useState(false);


    // => PAYLOAD
    const [uid, setUID] = useState(-1);
    const [name, setName] = useState('');
    const [surname, setSurname] = useState('');
    const [email, setEmail] = useState('');
    const [email2, setEmail2] = useState('');
    const [reference, setReference] = useState('');
    const [password, setPassword] = useState('');
    const [password2, setPassword2] = useState('');
    const [phone, setPhone] = useState('');
    const [system_role, setSystemRole] = useState('');

    const [regione, setRegione] = useState('');
    const [provincia, setProvincia] = useState('');
    const [comune, setComune] = useState('');

    const [status, setStatus] = useState('STATUS_ACTIVE');

    const [jsonRegion, setJSONRegion] = useState(JSONRegions.italy_regions);
    const [jsonProvince, setJSONProvince] = useState(JSONProvincies.italy_provincies);
    const [jsonCity, setJSONCity] = useState(JSONCities.italy_cities);

    //const [payload, setPayload] = useState(payloadUser)
    const [errors, setErrors] = useState(payloadUser)
    const [formErrors, setFormErrors] = useState(payloadUser);

    const setField = (field: any, value: any) => {

        //console.log('setField: ' + field + ' = ' + value);

        /*
        setPayload({
            ...payload,
            [field]: value
        })
        */

        if(field === 'uid') { setUID(value); }
        else if(field === 'name') { setName(value); }
        else if(field === 'surname') { setSurname(value); }
        else if(field === 'email') { setEmail(value); }
        else if(field === 'email2') { setEmail2(value); }
        else if(field === 'password') { setPassword(value); }
        else if(field === 'password2') { setPassword2(value); }
        else if(field === 'phone') { setPhone(value); }
        else if(field === 'system_role') { setSystemRole(value); }
        else if(field === 'regione') { setRegione(value); }
        else if(field === 'provincia') { setProvincia(value); }
        else if(field === 'comune') { setComune(value); }
        else if(field === 'status') { setStatus(value); }
        else if(field === 'reference') { setReference(value); }

        // remove error object:
        setErrors({
            ...errors,
            [field]: ''
        })
    }


    const findFormErrors = (blurField = defaultEMPTY) => {
        setFormErrors(payloadUser);

        formErrors.name = '';
        if (!name || name === '' || name === defaultEMPTY) { formErrors.name = t('messages.mandatoryField'); }
        formErrors.surname = '';
        if (!surname || surname === '' || surname === defaultEMPTY) { formErrors.surname = t('messages.mandatoryField'); }

        formErrors.email = formErrors.email2 = '';
        if (!email || email === '' || email === defaultEMPTY)
        {
            formErrors.email = t('messages.mandatoryField');
            if(blurField
                && blurField !== defaultEMPTY
                && blurField ===  'email')
            {
                setErrors({...errors, email: t('messages.mandatoryField')});
                return formErrors;
            }
        }
        else {
            if (!/\S+@\S+\.\S+/.test(email)) {
                formErrors.email = t('messages.invalidEmailAddress');

                if(blurField
                    && blurField !== defaultEMPTY
                    && blurField ===  'email')
                {
                    setErrors({...errors, email: t('messages.invalidEmailAddress')});
                    return formErrors;
                }
            }
        }
        if (!email2 || email2 === '' || email2 === defaultEMPTY)
        {
            formErrors.email2 = t('messages.mandatoryField');
            if(blurField
                && blurField !== defaultEMPTY
                && blurField ===  'email2')
            {
                setErrors({...errors, email2: t('messages.mandatoryField')});
                return formErrors;
            }
        }
        else {
            if (!/\S+@\S+\.\S+/.test(email2)) {
                formErrors.email2 = t('messages.invalidEmailAddress');

                if(blurField
                    && blurField !== defaultEMPTY
                    && blurField ===  'email2')
                {
                    setErrors({...errors, email2: t('messages.invalidEmailAddress')});
                    return formErrors;
                }
            }
        }

        if (email && email2 && email !== email2)
        {
            formErrors.email2 = t('messages.wrongEmailAddress');
            if(blurField
                && blurField !== defaultEMPTY
                && blurField ===  'email2')
            {
                setErrors({...errors, email2: t('messages.wrongEmailAddress')});
                return formErrors;
            }
        }

        /*
        if (!password || password === '') { formErrors.password = mandatoryMessageDefault }
        if (!password2 || password2 === '') { formErrors.password2 = mandatoryMessageDefault }
        if (password && password2 && password !== password2)
        {
            formErrors.password2 = 'Password non corretta!';
        }

        if (!phone || phone === '') { formErrors.phone = mandatoryMessageDefault }
        if (!regione || regione === '' || regione === 'NONE') { formErrors.regione = mandatoryMessageDefault }
        if (!provincia || provincia === '' || provincia === 'NONE') { formErrors.provincia = mandatoryMessageDefault }
        if (!comune || comune === '' || comune === 'NONE') { formErrors.comune = mandatoryMessageDefault }
        */

        //formErrors.reference = '';
        //if (!reference || reference === '' || reference === defaultEMPTY) { formErrors.reference = t('messages.mandatoryField'); }

        formErrors.system_role = '';
        if (!system_role || system_role === '') { formErrors.system_role = t('messages.mandatoryField'); }


        return formErrors
    }



    const handleSubmitThisOne = (e: any) => {
        //console.log('handleSubmitThisOne');

        const f = e.target;
        e.preventDefault();
        e.stopPropagation();

        const er = findFormErrors()
        const validated = Object.values(er).filter(x => x !== '' && x !== -1);
        //console.log(validated);
        if (validated.length > 0 ) {
            //alert('findFormErrors: '+ validated.length);
            setErrors(er)
        }
        else {
            //alert('form.checkValidity(): ' + f.checkValidity());
            if (f.checkValidity()) {
                const payload = {
                    uid,
                    name,
                    surname,
                    email,
                    //password,
                    phone,
                    system_role,
                    regione,
                    provincia,
                    comune,
                    status,
                    reference
                };

                //console.log(payload);
                //console.log('USERFORM - POST!');


                axios.post('/api/user', payload, {
                    headers: {
                        'Accept': 'application/json'
                    }
                }).then(response => {
                    //console.log('USERFORM - POST - response');
                    //alert(response);

                    window.location.reload();
                }).catch(error => {
                    //console.log('USERFORM - POST - ERROR');
                    //console.log(error.response.data);

                    toast.warning(error.response.data.message);
                });

            }
        }

    };
    const handleCancel = (e: any) => {
        const f = e.target;
        e.preventDefault();
        e.stopPropagation();

        //console.log('USERFORM - handleCancel!');
        location.reload();
    };
    const handleSendLoginInfoMail = () => {
        const payload = {
            uid
        };

        axios.post('/api/logininfo-email', payload, {
            headers: {
                'Accept': 'application/json'
            }
        }).then(response => {
            if(response.data.status)
                toast.success(t('messages.succesLoginInfoEmail'));
            else
                toast.warning(t('messages.defaultErrorMessage'));
        }).catch(error => {
            //console.log('USERFORM - POST - ERROR');
            console.log(error.response.data);
            toast.error(error.response.data.message);
        });
    };

    const handleActivate = (e: any) => {
        //console.log('handleActivate');
        const f = e.target;
        e.preventDefault();
        e.stopPropagation();

        const payload = {
            uid
        };

        axios.post('/api/user-activate', payload, {
            headers: {
                'Accept': 'application/json'
            }
        }).then(response => {
            //alert(response);
            window.location.reload();
        }).catch(error => {
            console.log(error);
            toast.error(error.response.data.message);
        });
    };
    const handleDestroy = (e: any) => {
        //console.log('handleActivate');
        const f = e.target;
        e.preventDefault();
        e.stopPropagation();

        const payload = {
            uid
        };

        axios.post('/api/user-destroy', payload, {
            headers: {
                'Accept': 'application/json'
            }
        }).then(response => {
            //alert(response);
            window.location.reload();
        }).catch(error => {
            console.log(error);
            toast.error(error.response.data.message);
        });
    };

    useEffect(() => {
        //console.log('useEffect - form.regione: ' + regione);
        if(regione && regione !== '')
        {
            setJSONProvince(JSONProvincies.italy_provincies.filter(x => x.id_regione === regione));
            const p = JSONRegions.italy_regions.find(x => x.id_regione === regione);
            if(p)
            {
                var r = p?.regione;
                setJSONCity(JSONCities.italy_cities.filter(x => x.regione === r));
            }
        }
        else
            setJSONProvince(JSONProvincies.italy_provincies);
    }, [regione])
    useEffect(() => {
        //console.log('useEffect - form.provincia: ' + provincia);

        if(provincia && provincia !== '')
            setJSONCity(JSONCities.italy_cities.filter(x => x.provincia === provincia));
        else
            setJSONCity(JSONCities.italy_cities);

    }, [provincia])
    useEffect(() => {
        if(user)
        {
            setFormData();
        }
    }, [user])

    const setFormData = () => {
        //console.log('setFormData - yourProfile: '+ yourProfile);
        if(yourProfile) {
            setField('uid', user.user.id)
            setField('name',  user.user.name);
            setField('surname', user.user.surname);
            setField('email', user.user.email);
            setField('email2', user.user.email);
            setField('phone', user.user.phone_number);
            setField('system_role', user.user.system_role);

            setField('regione', user.user.system_region);
            setField('provincia', user.user.system_province);
            setField('comune', user.user.system_town);
            setField('reference', user.user.reference);
        }
        else
        {
            if(data)
            {
                setField('uid', data.id)
                setField('name',  data.name);
                setField('surname', data.surname);
                setField('email', data.email);
                setField('email2', data.email);
                setField('phone', data.phone_number);
                setField('system_role', data.system_role);
                setField('regione', data.system_region);
                setField('provincia', data.system_province);
                setField('comune', data.system_town);
                setField('reference', data.reference);

                setField('status', data.status);
            }
            else
            {
                setField('system_role', '');
            }
        }
    }

    return (
        <Container className="col col-lg-7 mx-auto my-4">
            <Form noValidate onSubmit={e => handleSubmitThisOne(e)}>
            <Row className="mt-1">
                <Form.Group as={Col} controlId="validation_Name">
                    <FloatingLabel
                        controlId="floating_Name"
                        label={t('labels.name*')}
                        className="mb-3"
                    >
                        <Form.Control required
                                      type="text"
                                      placeholder={t('labels.name*').toString()}
                                      value={name}
                                      onFocus={() => setErrors({...errors, name: ''})}
                                      onChange={e => setField('name', e.target.value)}
                                      isInvalid={!!errors.name}
                        />
                        <Form.Control.Feedback type="invalid">{errors.name}</Form.Control.Feedback>
                    </FloatingLabel>
                </Form.Group>
            </Row>
            <Row className="mt-1">
                <Form.Group as={Col} controlId="validation_Surname">
                    <FloatingLabel
                        controlId="floating_Surname"
                        label={t('labels.surname*')}
                        className="mb-3"
                    >
                        <Form.Control required
                                      type="text"
                                      placeholder={t('labels.surname*').toString()}
                                      value={surname}
                                      onChange={e => { setField('surname', e.target.value)}}
                                      onFocus={() => setErrors({...errors, surname: ''})}
                                      isInvalid={!!errors.surname}
                        />
                        <Form.Control.Feedback type="invalid">{errors.surname}</Form.Control.Feedback>
                    </FloatingLabel>
                </Form.Group>
            </Row>
            <Row className="mt-1">
                <Form.Group as={Col} controlId="validation_Phone" className="mb-3">
                    <Form.Label className={'float-left'}>{t('labels.mobile')}</Form.Label>
                    <PhoneInput
                        country='it'
                        inputProps={{
                            name: 'phone',
                            //required: true
                        }}
                        placeholder={t('labels.mobile').toString()}
                        value={phone}
                        onChange={e => setField('phone', e)}
                        disableDropdown={true}
                        inputStyle={{
                            width: "100%",
                            height: "56px"
                        }}
                    />
                </Form.Group>
            </Row>
            <Row className="mt-1">
                <Form.Group as={Col} controlId="validation_Email">
                    <FloatingLabel
                        controlId="floating_Email"
                        label={t('labels.mail*')}
                        className="mb-3"
                    >
                        <Form.Control required
                                      type="email"
                                      placeholder={t('labels.mail*').toString()}
                                      value={email}
                                      onChange={e => setField('email', e.target.value)}
                                      onFocus={() => setErrors({...errors, email: ''})}
                                      isInvalid={!!errors.email}
                                      onBlur={() => findFormErrors('email')}
                        />
                        <Form.Control.Feedback type="invalid">{errors.email}</Form.Control.Feedback>
                    </FloatingLabel>
                </Form.Group>
            </Row>
            <Row className="mt-1">
                <Form.Group as={Col} controlId="validation_Email2">
                    <FloatingLabel
                        controlId="floating_Email2"
                        label={t('labels.mailRepeat*')}
                        className="mb-3"
                    >
                        <Form.Control required
                                      type="email"
                                      placeholder={t('labels.mailRepeat*').toString()}
                                      value={email2}
                                      onChange={e => setField('email2', e.target.value)}
                                      onFocus={() => setErrors({...errors, email2: ''})}
                                      isInvalid={!!errors.email2}
                                      onBlur={() => findFormErrors('email2')}
                        />
                        <Form.Control.Feedback type="invalid">{errors.email2}</Form.Control.Feedback>
                    </FloatingLabel>
                </Form.Group>
            </Row>
            <Row className="mt-1">
                <Form.Group as={Col} controlId="validation_Reference">
                    <FloatingLabel
                        controlId="floating_Reference"
                        label={t('labels.reference')}
                        className="mb-3"
                    >
                        <Form.Control //required
                                      type="text"
                                      placeholder={t('labels.reference').toString()}
                                      value={reference}
                                      onFocus={() => setErrors({...errors, reference: ''})}
                                      onChange={e => setField('reference', e.target.value)}
                                      isInvalid={!!errors.reference}
                        />
                        <Form.Control.Feedback type="invalid">{errors.reference}</Form.Control.Feedback>
                    </FloatingLabel>
                </Form.Group>
            </Row>
            <Row className="mt-5 mb-4">
                <Form.Group md="4" as={Col} controlId="validation_REGIONE">
                    <FloatingLabel
                        controlId="floating_REGIONE"
                        label={t('labels.region')}
                        className="mb-3"
                    >
                        <Form.Select size={'sm'}
                                     value={regione}
                                     onChange={e => setField('regione', e.target.value)}
                                     aria-label="floating_REGIONE select"
                                     disabled={user && user.user.role === 'ROLE_USER'}
                        >
                            <option key={defaultNONE} value={''}></option>
                            {
                                jsonRegion.map(({id_regione, regione}) => (
                                    <option key={id_regione} value={id_regione} >{regione}</option>
                                ))
                            }
                        </Form.Select>
                    </FloatingLabel>
                </Form.Group>
                <Form.Group md="4" as={Col} controlId="validation_PROVINCIA">
                    <FloatingLabel
                        controlId="floating_PROVINCIA"
                        label={t('labels.province')}
                        className="mb-3"
                    >
                        <Form.Select size={'sm'}
                                     value={provincia}
                                     onChange={e => setField('provincia', e.target.value)}
                                     aria-label="floating_PROVINCIA select"
                                     disabled={user && user.user.role === 'ROLE_USER'}
                        >
                            <option key={defaultNONE} value={''}></option>
                            {
                                //sigla": "AG",
                                //       "provincia": "Agrigento",
                                //       "superficie": "3052.59",
                                //       "residenti": "446081",
                                //       "num_comuni": "43",
                                //       "id_regione": "15",
                                jsonProvince.map(({sigla, provincia, id_regione}) => (
                                    <option key={sigla} value={sigla} >{provincia}</option>
                                ))
                            }
                        </Form.Select>
                    </FloatingLabel>
                </Form.Group>
                <Form.Group md="4" as={Col} controlId="validation_COMUNE">
                    <FloatingLabel
                        controlId="floating_COMUNE"
                        label={t('labels.town')}
                        className="mb-3"
                    >
                        <Form.Select
                            size={'sm'}
                            //defaultValue={defaultNONE}
                            value={comune}
                            onChange={e => setField('comune', e.target.value)}
                            aria-label="floating_COMUNE select"
                            disabled={user && user.user.role === 'ROLE_USER'}
                        >
                            <option key={defaultNONE} value={''}></option>
                            {
                                //"istat": "1001",
                                //                         "comune": "Agliè",
                                //                         "regione": "Piemonte",
                                //                         "provincia": "TO",
                                //                         "prefisso": "0124",
                                //                         "cod_fisco": "A074",
                                //                         "num_residenti": "2545",
                                //                         "superficie": "13.28"

                                jsonCity.map(({istat, comune, provincia}) => (
                                    <option key={istat} value={istat}>{comune}</option>
                                ))
                            }
                        </Form.Select>
                    </FloatingLabel>
                </Form.Group>
            </Row>
            <Row className="mt-6">
                <Form.Group className="mt-1" controlId="field-role">
                    <FloatingLabel
                        controlId="floating_ROLE"
                        label={t('labels.role*')}
                        className="mb-3"
                    >
                        <Form.Select
                            size={'sm'}
                            required
                            disabled={user && user.user.role === 'ROLE_USER'}
                            value={system_role}
                            onChange={e => setField('system_role', e.target.value)}
                            onFocus={() => setErrors({...errors, system_role: ''})}
                            isInvalid={!!errors.system_role}
                        >
                            <option key={defaultNONE} value={''}></option>
                            {
                                JSONSystemRoles.system_roles
                                    .map((
                                        {
                                            uid,
                                            key,
                                            description
                                        }, idx) => (
                                        <option key={idx} value={key} >{description}</option>
                                    ))
                            }
                        </Form.Select>
                    </FloatingLabel>
                    <Form.Control.Feedback type="invalid">{errors.system_role}</Form.Control.Feedback>
                </Form.Group>
            </Row>

            <Row>
                <Container as={Col} className="gestione centered">
                    {
                        user
                        && user.user.role !== 'ROLE_USER'
                        && status !== 'STATUS_ACTIVE'
                        && (
                            <button className="btn full-width mt-3" onClick={handleActivate}>Attiva</button>
                        )
                    }
                    {
                        user
                        && user.user.role !== 'ROLE_USER'
                        && status === 'STATUS_ACTIVE'
                        && data
                        && (
                            <>
                                <Row>
                                    <Col>
                                        <Button className="btn_1 full-width text-white" variant="danger" onClick={() => setShowUserDestroyConfirmationModal(true)}>
                                            {t('captions.remove')}
                                        </Button>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <Button className="btn_1 full-width text-white" variant="primary" onClick={handleSendLoginInfoMail}>
                                            {t('captions.logInfoMail')}
                                        </Button>
                                    </Col>
                                </Row>
                            </>
                        )
                    }
                    <Row>
                        <Col>
                            <Button type="submit" className="btn_1 full-width green text-white" variant="outline">{t('captions.save')}</Button>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <Button className="btn_1 full-width yellow text-white" variant="outline" onClick={handleCancel}>{t('captions.cancel')}</Button>
                        </Col>
                    </Row>
                </Container>
            </Row>
            </Form>
            <UserDestroyConfirmation
                uID={uid}
                show={showUserDestroyConfirmationModal}
                onHide={() => setShowUserDestroyConfirmationModal(false)}/>
        </Container>
    );
};

export default UserForm;
